import { contractStore } from '@stores/contractStore';

/**
 * Event types for DataLayer.
 *
 * @link https://satocorporation.atlassian.net/wiki/spaces/SW/pages/5110497304/OmaSATO+analytiikka#%5CuD83D%5CuDCCA-Tapahtumat-(Events)
 */
export enum GA_EVENT_TYPES {
  /** Generic link event */
  LINK_CLICK = 'link_click_event',
  /** User terminates a sauna reservation contract */
  CANCEL_SAUNA_RESERVATION = 'CancelReservation',
  /** User clicks a customer benefit link */
  CUSTOMER_BENEFIT_OUTGOING_CLICK = 'outgoing_click',
  /** User logs in to OmaSATO */
  LOGIN = 'userLogin',
  /** User logs out from OmaSATO */
  LOGOUT = 'logout',
  /** User has successfully updated their profile info */
  EDIT_MY_INFO = 'EditMyInfo',
  /** User enters Contract page (ContractPage) */
  VIEW_CONTRACT = 'ViewContract',
  /** User clicks a link in sub nav of MyInformationPage. TODO: can probably be removed. */
  SUBNAV_CLICK = 'subnav_click',
}

export interface EventBase {
  event: GA_EVENT_TYPES;
}

export type LinkContextType =
  | 'omasato-apartment-recommendations-near'
  | 'omasato-apartment-recommendations-farther';

export interface LinkClickEvent extends EventBase {
  event: GA_EVENT_TYPES.LINK_CLICK;
  /** Link target */
  href: string;
  /** Descriptive contextual identifier for the event for explaining where the link is being used */
  linkContext: LinkContextType;
  // TODO: Not tracked. Could be removed or renamed to `context` that is actually tracked in GA.
  /** Context of the content, i.e. whether the link is being managed inside the code (omasato) or contentful */
  contentContext: 'contentful' | 'omasato';
}

export interface CustomerBenefitOutgoingClickEvent extends EventBase {
  event: GA_EVENT_TYPES.CUSTOMER_BENEFIT_OUTGOING_CLICK;
  // TODO: `clickTarget` and `module` are not defined in GA custom dimensions, and thus are not actually tracked.
  //       We should probably switch to using link click event `href` and `linkContext` respectively.
  clickTarget: string;
  module: string;
}

export interface UserLoginEvent extends EventBase {
  event: GA_EVENT_TYPES.LOGIN;
  userType: typeof contractStore.userSeekerStatus;
}

export interface SubNavClickEvent extends EventBase {
  event: GA_EVENT_TYPES.SUBNAV_CLICK;
  // TODO: `clickTarget` and `module` are not defined in GA custom dimensions, and thus are not actually tracked.
  //       We should probably switch to using link click event `href` and `linkContext` respectively.
  clickTarget: string;
  module: string;
}
